/**
 * Прокрутка к узлу так, чтобы его верх встал сразу под нависающей шапкой:
 * сквозная промо-плашка (--promo-bar-h) плюс фиксированное меню h-16 и
 * 8 px воздуха. scrollIntoView этого отступа не знает и прячет верх узла
 * под шапку.
 *
 * onlyIfCovered — двигать страницу, только если верх узла закрыт шапкой
 * или ушёл выше экрана (ПК после «РАССЧИТАТЬ»: без нужды не дёргаем).
 * Возвращает true, если прокрутка была.
 */
export function headerOffset() {
  if (typeof window === 'undefined') return 0;
  const bar = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--promo-bar-h') || '0', 10) || 0;
  return bar + 64 + 8;
}

export default function scrollUnderHeader(el, { smooth = true, onlyIfCovered = false } = {}) {
  if (!el || typeof window === 'undefined') return false;
  const offset = headerOffset();
  const rectTop = el.getBoundingClientRect().top;
  if (onlyIfCovered && rectTop >= offset - 8) return false;
  // Уже на месте — не дёргаем (повторное выравнивание после досчёта).
  if (Math.abs(rectTop - offset) < 4) return false;
  window.scrollTo({ top: Math.max(0, rectTop + window.scrollY - offset), behavior: smooth ? 'smooth' : 'auto' });
  return true;
}
